import { Box } from "@mui/material";
import styled from "styled-components";
import { useEffect, useRef } from "react";
import LogoDG from "../../assets/images/logo/logo_0_0.png";
import AnimateOnScroll from "../../components/AnimateOnScroll";
import { RDVButton, SubtitleSection } from "../../components/commonWidgets";
import HighlightTitle from "../../components/HighlightTitle";
import {
  FiGlobe,
  FiSmartphone,
  FiSearch,
  FiTrendingUp,
  FiCpu,
} from "react-icons/fi";
import ScrollingBadges from "../../components/ScrollingBadges";

// === STYLED COMPONENTS ===
const Carousel = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -2px;

  &.is_mobile {
    margin-top: 0px !important;
  }
`;

const CarouselContainer = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ParticleBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  opacity: 0.5;
  z-index: 1;
  top: 0;
  left: 0;
`;

const BannerHeader = styled.div`
  margin: 2rem;
  font-size: var(--title-size);
  color: var(--my-color3);
  text-align: center;

  img {
    width: 55%;
    margin: auto;
    max-width: 15rem;
  }
`;

const BannerTitle = styled.div`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--my-color5);
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
`;

const BannerText = styled.div`
  margin-bottom: 0rem;
  font-size: 2rem;
  color: var(--my-color3);
  display: contents;
  line-height: 2rem;
  margin: auto;
  z-index: 99;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
`;

const HeroSection = () => {
  const carouselRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const resize = () => {
      const header = document.getElementById("site-header__inner");
      const headerHeight = header?.getBoundingClientRect().height || 0;

      if (carouselRef.current) {
        carouselRef.current.style.marginTop = `-${headerHeight}px`;
      }

      if (containerRef.current) {
        containerRef.current.style.marginTop = `${headerHeight}px`;
      }
    };

    resize();
    window.addEventListener("resize", resize);

    // === Charger particles.js dynamiquement ===
    const script = document.createElement("script");
    script.src = "/js/particles.min.js";
    script.onload = () => {
      if (window.particlesJS) {
        window.particlesJS.load("particles-js", "/particles.json", function () {
          console.log("Particles.js config loaded");
        });
      }
    };
    document.body.appendChild(script);

    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        backgroundImage: "url(/hero.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "white",
      }}
    >
      <Carousel id="wordCarousel" ref={carouselRef}>
        <ParticleBackground
          id="particles-js"
          style={{ pointerEvents: "none" }}
        />
        <CarouselContainer id="wordCarousel-container" ref={containerRef}>
          <BannerHeader>
            <img src={LogoDG} alt="digibuddy-logo" />
          </BannerHeader>
          <HighlightTitle
            text="Sites & apps qui accélèrent vos ventes"
            highlightWord="accélèrent"
            bg="var(--my-color4)"
            textColor="white"
            mainTextColor="var(--my-color3)"
            angle="-2deg"
            rotateText={true}
          />
          <BannerText>
            <SubtitleSection
              style={{
                margin: "1.2rem 0rem",
                fontSize: "1.1rem",
                textAlign: "center",
                margin: "0 2rem",
              }}
            >
              De la première impression au paiement, <br />
              chaque écran convertit vos prospects en clients.
            </SubtitleSection>
          </BannerText>
          <ScrollingBadges
            speed={6}
            style={{
              width: "25rem",
              maxWidth: "80%",
              backgroundColor: "transparent",
              margin: "0.5rem auto",
            }}
            items={[
              { icon: <FiGlobe />, label: "Web" },
              { icon: <FiSmartphone />, label: "Mobile" },
              { icon: <FiSearch />, label: "SEO" },
              { icon: <FiTrendingUp />, label: "Ads" },
              { icon: <FiCpu />, label: "Logiciel" },
            ]}
          />
          <AnimateOnScroll type="grow">
            <div style={{ marginTop: "2rem" }}>
              <RDVButton label="Diagnostic gratuit" />
            </div>
          </AnimateOnScroll>
        </CarouselContainer>
      </Carousel>
    </Box>
  );
};

export default HeroSection;
